import * as React from "react";
import NextLink from "components/parts/NextLink";
import { NavContext } from "../main-nav/nav-context";
import { usePathname } from "i18n/routing";

interface NavLinkProps {
  href: string;
  as?: string;
  className?: string;
  newTab?: boolean;
  id?: string;
  children?: React.ReactNode;
  useReferrerPolicy?: boolean;
}

const NavLink: React.FC<NavLinkProps> = ({ href, as, children, ...rest }) => {
  const pathname = usePathname();
  const { handleCloseMenu } = React.useContext(NavContext);
  const onClickHandler =
    pathname === href ? { onClick: handleCloseMenu } : null;

  const props = {
    ...onClickHandler,
    ...rest,
    href,
    as
  };

  return <NextLink {...props}>{children}</NextLink>;
};

export default NavLink;
